import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  active: false,
  value: 0,
  channelId: null,
  message: null,
  // Context for completion handling (optional)
  invalidateLDIDs: [],
  invalidatePRRIDs: [],
  selectedAll: false,
  routeId: null, // e.g., "item-details" or other
  successMessage: null,
};

export const progressSlice = createSlice({
  name: "progress",
  initialState,
  reducers: {
    startProgress: (state, action) => {
      const {
        channelId,
        message = null,
        invalidateLDIDs = [],
        invalidatePRRIDs = [],
        selectedAll = false,
        routeId = null,
        successMessage = null,
      } = action.payload || {};
      state.active = true;
      state.value = 0;
      state.channelId = channelId || null;
      state.message = message;
      state.invalidateLDIDs = Array.isArray(invalidateLDIDs) ? invalidateLDIDs : [];
      state.invalidatePRRIDs = Array.isArray(invalidatePRRIDs) ? invalidatePRRIDs : [];
      state.selectedAll = Boolean(selectedAll);
      state.routeId = routeId;
      state.successMessage = successMessage;
    },
    setProgressValue: (state, action) => {
      const v = Number(action.payload);
      state.value = Number.isFinite(v) ? v : state.value;
    },
    stopProgress: (state) => {
      state.active = false;
      state.value = 0;
      state.channelId = null;
      state.message = null;
      state.invalidateLDIDs = [];
      state.invalidatePRRIDs = [];
      state.selectedAll = false;
      state.routeId = null;
      state.successMessage = null;
    },
  },
});

export const {
  startProgress,
  setProgressValue,
  stopProgress,
} = progressSlice.actions;

export const selectProgress = (state) => state.progress;

export default progressSlice.reducer;

